<div class="dialog">
    <h2 class="dialog__title">Choose you planning mode</h2>

    <p class="dialog__description">
        Do you need our experts’ help or you want to give it a go on your own?
        <br/>
        <br/>
        Choose <span class="planning-mark">Manual mode</span> to edit your trip manually <br/>or<br/>
        Use <span class="planning-mark planning-mark--optimize">Optimize mode</span> to let RoutePerfect system improve
        your plan while you modify it:
    </p>

    <ul class="features-list">
        <li>
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.667 0.3479C16.1134 0.811768 16.1134 1.56509 15.667 2.02895L6.52411 11.529C6.07768 11.9928 5.35268 11.9928 4.90625 11.529L0.334821 6.77896C-0.111607 6.31509 -0.111607 5.56177 0.334821 5.0979C0.78125 4.63403 1.50625 4.63403 1.95268 5.0979L5.71696 9.00552L14.0527 0.3479C14.4991 -0.115967 15.2241 -0.115967 15.6705 0.3479H15.667Z" fill="#8DCB27"/>
            </svg>
            <span>Reduce driving time</span>
        </li>
        <li>
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.667 0.3479C16.1134 0.811768 16.1134 1.56509 15.667 2.02895L6.52411 11.529C6.07768 11.9928 5.35268 11.9928 4.90625 11.529L0.334821 6.77896C-0.111607 6.31509 -0.111607 5.56177 0.334821 5.0979C0.78125 4.63403 1.50625 4.63403 1.95268 5.0979L5.71696 9.00552L14.0527 0.3479C14.4991 -0.115967 15.2241 -0.115967 15.6705 0.3479H15.667Z" fill="#8DCB27"/>
            </svg>
            <span>Focus on top touristic destinations</span>
        </li>
        <li>
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.667 0.3479C16.1134 0.811768 16.1134 1.56509 15.667 2.02895L6.52411 11.529C6.07768 11.9928 5.35268 11.9928 4.90625 11.529L0.334821 6.77896C-0.111607 6.31509 -0.111607 5.56177 0.334821 5.0979C0.78125 4.63403 1.50625 4.63403 1.95268 5.0979L5.71696 9.00552L14.0527 0.3479C14.4991 -0.115967 15.2241 -0.115967 15.6705 0.3479H15.667Z" fill="#8DCB27"/>
            </svg>
            <span>Adjust the itinerary to your preferences</span>
        </li>
    </ul>

    <div class="dialog__actions">
        <button class="dialog__button dialog__button--confirm" (click)="closeModal(true)">Got it</button>
    </div>
</div>
